export default __webpack_public_path__ + "static/media/virtual-tutoring-icon.5b48f011.png";